module.exports = __webpack_public_path__ + "/bundle/asset/U2_04-8292990845d0ec79911b4d525f407460.gif";